<template>
  <v-flex v-if="dialog" fullscreen hide-overlay transition="none" style="overflow-x: hidden;">
    <v-card>
      <Spinner ref="spinner"></Spinner>
      <div class="mb-4">
        <zigZag></zigZag>
      </div>
      <v-layout text-xs-center mt-5>
        <v-flex mb-0 xs12 mx-2>
          <v-layout justify-start row mx-3 mt-0 align-center>
            <v-flex>
              <v-layout row>
                <!-- <v-icon class="mr-2">fa-plus-circle</v-icon> -->
                <div
                  class="text-xs-left"
                  style="font-size: 20px; font-weight: 600;"
                >Batch {{batch.batchId}} - {{batch.typeId == "CA" ? "PAYMENT": "ADJUSTMENT"}}</div>
              </v-layout>
            </v-flex>
            <v-flex>
              <!-- <v-layout row>
                  <v-flex>
                    <v-layout class="buttons mb-0 mr-0" justify-end row>
                      <v-btn icon @click="cancel" class="pa-0 mr-0">
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-flex>
              </v-layout>-->
              <v-layout class="buttons" justify-end row align-center>
                <a
                  v-if="batchRecords.length > 0"
                  style="text-decoration: none"
                  class="align-center"
                  @click="exportToExcel"
                >EXCEL</a>
                <v-btn
                  v-if="formType=='edit'"
                  class="TierButton mb-1 mr-0 ml-4"
                  @click="openCreateBatchRecord().then(()=>{$vuetify.goTo('#createBatchRecord')})"
                >+ New Record</v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
          <v-layout pa-0 ma-0 mr-0 pr-0 mt-2 mx-3>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="batchRecords"
                :item-key="batchRecords.index"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :loading="loading"
                :total-items="totalRecords"
                @update:pagination="paginationUpdated"
                hide-details
                class="striped-table no-pagination-btn"
              >
                <template slot="items" slot-scope="props">
                  <tr
                    :key="props.index"
                    :active="props.selected"
                    :style="{
                        backgroundColor: (props.item.DocumentId == selectedRow ? '#C6EFCE' : '' ), 
                        color: (props.item.DocumentId == selectedRow ? '#00612e' : 'black' ),
                      }"
                  >
                    <td class="text-xs-left px-0">{{ formatDate(props.item["Date"]) }}</td>
                    <td class="text-xs-left px-0">
                      {{
                      props.item["Type"]}}
                    </td>
                    <td class="text-xs-left px-0">
                      <router-link
                        class="mr-3"
                        style="text-decoration: none"
                        :to="openAccountSummaryPage(props.item)"
                      >{{ props.item["BAN"] }}</router-link>
                    </td>
                    <td
                      class="text-xs-left px-0"
                    >{{ props.item["AccountName1"] }} {{props.item["AccountName2"] != null ? props.item.AccountName2 : ""}}</td>
                    <td class="text-xs-left px-0">{{ props.item["Reference"] }}</td>

                    <td class="text-xs-left px-0">{{ props.item["DocumentId"] }}</td>
                    <td
                      :class="{'justify-end text-xs-right pr-2': props.item.Amount >= 0, 'justify-end text-xs-right pr-2 red--text': props.item.Amount < 0}"
                    >{{ formatCurrency(props.item["Amount"]) }}</td>
                    <td class="text-xs-right px-0">
                      <!-- <a class="mr-2" style="text-decoration: none" @click>POST</a> -->
                      <a
                        v-if="formType=='edit'"
                        class="mr-2"
                        style="text-decoration: none"
                        @click="openEditBatchRecord(props.item).then(()=>{$vuetify.goTo('#createBatchRecord')})"
                      >EDIT</a>
                      <a
                        v-if="formType=='edit'"
                        class="mr-0"
                        style="text-decoration: none"
                        @click="deleteRecord(props.item)"
                      >DELETE</a>
                    </td>
                  </tr>
                </template>
                <template slot="footer">
                  <tr>
                    <td class="text-xs-left pl-0" colspan="3">
                      <strong>
                        Total
                        Records:
                      </strong>
                      {{ totalRecords }}
                    </td>
                    <td class="text-xs-right" colspan="2"></td>
                    <td class="justify-end text-xs-right pr-2" colspan="2">
                      <v-layout row>
                        <v-flex xs8>
                          <strong>Total Amount:</strong>
                        </v-flex>
                        <v-flex
                          xs4
                          :class="{'red--text': totalAmount < 0}"
                        >{{ formatCurrency(totalAmount) }}</v-flex>
                      </v-layout>
                    </td>
                    <td class="text-xs-right">
                      <strong></strong>
                    </td>
                  </tr>
                </template>
                <template slot="actions-append">
                  <data-table-pagination :rowsPerPage="pagination.rowsPerPage" :totalRecords="totalRecords" v-model="pagination.page" @input="paginationUpdated()"></data-table-pagination>
                  </template>
              </v-data-table>
              <!-- END EDIT BATCHES Table-->
            </v-flex>
          </v-layout>
          <createBatchRecord
            ref="createBatchRecord"
            @parentRefresh="initialize"
            @parentInitSelectedRow="initSelectedRow"
            id="createBatchRecord"
          ></createBatchRecord>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import Spinner from "../../components/Spinner.vue";
import axios from "axios";
import Bus from "../../bus";
import moment from "moment";
import zigZag from "../../components/ZigZag";
import createBatchRecord from "./CreateBatchRecord.vue";
import DataTablePagination from "../../components/DataTablePagination.vue";

export default {
  name: "Edit Batch",

  components: {
    Spinner,
    zigZag,
    createBatchRecord,
    DataTablePagination
  },

  data: () => ({
    dialog: false,
    valid: true,

    resolve: null,
    reject: null,
    batch: {},

    showResetBtn: false,

    search: "",
    loading: true,
    filtersChanged: false,
    totalRecords: 0,

    filters: {},

    ddlType: [],
    batchRecords: [],
    selectedRow: null,

    totalAmount: 0,
    formType: null,

    pagination: {
      page: 1,
      rowsPerPage: 5,
      descending: true,
      sortBy: "BatchId"
    },
    rowsPerPageItems: [5, 15, 30],

    headers: [
      {
        text: "Date",
        value: "Date",
        width: "7%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Type",
        value: "Type",
        width: "7%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Account",
        value: "BAN",
        width: "5%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Account Name",
        value: "AccountName",
        width: "30%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Reference",
        text: "Reference",
        value: "Records",
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Document ID",
        value: "DocumentId",
        width: "10%",
        fixed: true,
        align: "left",
        class: "pl-0 pr-0 font-weight-bold subheading"
      },
      {
        text: "Amount",
        value: "Amount",
        width: "10%",
        fixed: true,
        align: "right",
        class: "pl-0 pr-2 font-weight-bold subheading"
      },

      {
        text: "Actions",
        width: "20%",
        sortable: false,
        fixed: true,
        align: "right",
        class: "pl-0 pr-0 font-weight-bold subheading"
      }
    ]
  }),

  mounted() {
    // this.initialize();
  },
  methods: {
    initialize() {
      this.loading = true;
      this.filters = { BatchId: this.batch.batchId };
      this.filtersChanged = true;
      this.showResetBtn = false;
      this.selectedRow = null;

      this.paginationUpdated();

      this.loading = false;
      // this.getDropdownOptions("api/Account/GetEditAccountDdls", "ddlAccountTypes")
    },
    formatCurrency(value) {
      var absValue = Math.abs(value);
      var returnString = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD"
      }).format(absValue);

      return value < 0 ? "(" + returnString + ")" : returnString;
    },
    formatDate(value) {
      if (value) return moment(value).format("YYYY-MM-DD");
      else return "";
    },
    async filterBatches() {
      this.filtersChanged = true;
      this.showResetBtn = true;
      await this.paginationUpdated();
    },
    async paginationUpdated() {
      this.loading = true;
      await axios
        .post(
          "/api/Receivables/GetPagedARBatchRecordList/",
          {
            postData: {
              pagination: this.pagination,
              filtersChanged: this.filtersChanged,
              filters: this.filters,
              search: this.search
            }
          },
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        )
        .then(response => {
          this.batchRecords = response.data.batchRecords;
          this.totalRecords = response.data.totalRecords;
          this.totalAmount = response.data.totalAmount;
        });
      this.loading = false;
      this.filtersChanged = false;
    },
    // Get list of dropdown options
    getDropdownOptions(url, obj) {
      axios
        .get(url)
        .then(resp => (this[`${obj}`] = resp.data[`${obj}`]))
        .catch(err => console.log(err));
    },
    async resetBatchList() {
      this.loading = true;
      this.$router.push("/active-batches");
      this.pagination.totalRecords = 0;
      this.filters = {};
      this.search = "";

      await this.paginationUpdated();

      this.showResetBtn = false;
      this.loading = false;
    },

    async open(item, formType) {
      this.batch = await Object.assign({}, item);
      this.formType = formType;
      this.dialog = true;

      this.initialize();
    },

    cancel() {
      if (this.dialog == true) {
        this.selectedRow = null;
      }

      (this.batch = {}), (this.dialog = false);
      // this.resolve(false);
      // this.$root.$emit("initialize", this.initialize);
      // this.resetFormFilters()
    },
    close() {
      if (this.dialog == true) {
        this.selectedRow = null;
      }

      (this.batchRecords = {}), (this.dialog = false);
      // this.resolve(true);
      this.$root.$emit("initialize", this.initialize);
    },
    isOpen() {
      return this.dialog;
    },
    async openCreateBatchRecord() {
      this.selectedRow = null;
      var date;
      if (this.batchRecords.length > 0) {
        date = this.formatDate(this.batchRecords[0].Date);
      } else {
        date = moment().format("YYYY-MM-DD");
      }
      var editBatch = await this.$refs.createBatchRecord.open({
        batchId: this.batch.batchId,
        type: this.batch.type,
        typeId: this.batch.typeId,
        date: date
      });
    },
    async openEditBatchRecord(item) {
      let index = this.batchRecords.indexOf(item);
      if (index > -1) {
        this.selectedRow = this.batchRecords[index].DocumentId;
      }

      var amount = Math.abs(item.Amount);
      var date = moment(item.Date, "YYYY-MM-DDTHH:mm:ss")
        .format("YYYY-MM-DD")
        .toString();

      var editBatch = await this.$refs.createBatchRecord.openEdit({
        batchId: item.BatchId,
        type: this.batch.type,
        typeId: item.DocTypeId,
        docTypeId: item.DocTypeId,
        date: date,
        BAN: item.BAN,
        reference: item.Reference,
        amount: amount,
        documentId: item.DocumentId
      });
    },
    openAccountSummaryPage(item) {
      return "/account-summary/" + item.BAN;
    },
    async deleteRecord(item) {
      var confirmDeleteRecord = confirm(
        "Are you sure you would like to delete this record from the batch?"
      );
      if (confirmDeleteRecord == true) {
        axios
          .put("api/Receivables/DeleteBatchRecord/" + item.DocumentId)
          .then(async res => {
            var isCreateBatchRecordOpen = await this.$refs.createBatchRecord.isOpen();
            if (isCreateBatchRecordOpen == true) {
              await this.$refs.createBatchRecord.cancel();
            }
            Bus.$emit("alert", {
              color: "success",
              message: "Batch Record Deleted Successfully"
            });
            this.initialize();
            this.$root.$emit("initialize", this.initialize);
          });
      }
    },
    initSelectedRow() {
      this.selectedRow = null;
    },
    exportToExcel() {
      this.$refs.spinner.spinOn();
      axios({
        url: "/api/Receivables/batchRecordsToExcel/",
        method: "POST",
        data: {
          postData: {
            pagination: this.pagination,
            filtersChanged: this.filtersChanged,
            filters: this.filters,
            search: this.search
          }
        },
        responseType: "blob"
      })
        .then(response => {
          var currentDate = moment().format("YYYYMMDD.HHmm");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "ActiveBatchRecords" +
              this.filters.BatchId +
              "." +
              currentDate +
              ".xlsx"
          ); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.$refs.spinner.spinOff();
        })
        .catch(err => {
          this.$refs.spinner.spinOff();
        });
    }
  },
  filters: {
    formatDateTime: function(date) {
      if (
        moment(date, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.S", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
        moment(date, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid()
      ) {
        return moment(date, "YYYY-MM-DDTHH:mm:ss").format(
          "YYYY/MM/DD h:mm:ss A"
        );
      }
    }
  }
};
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>

